module.exports = __webpack_public_path__ + "img/van.e1ccf0b3.jpg";